/**
 * Get query param search string from the url & return the object
 */
export function getQueryParams() {
  const queryParams = {};
  const params = new URLSearchParams(window.location.search);
  for (const name of params.keys()) {
    queryParams[name] = params.get(name);
  }

  return queryParams;
}
